<template>
  <div class="dashboard-disclosure">
    <button type="button" class="disclosure-toggle" :aria-expanded="expanded" :aria-controls="contentId" @click="toggle">
      <i class="bi-chevron-right" :class="{ expanded }" aria-hidden="true" />
      {{ label }}
    </button>
    <BCollapse :id="contentId" :show="expanded" disable-auto-scroll-on-show>
      <div v-if="openedOnce" class="disclosure-content"><slot /></div>
    </BCollapse>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { getCurrentInstance, ref } from 'vue';
import BCollapse from '@/components/common/BCollapse.vue';
defineProps({ label: { type: String, required: true } });
const emit = defineEmits(['toggle']);
const contentId = `dashboard-disclosure-${getCurrentInstance().uid}`;
const expanded = ref(false);
const openedOnce = ref(false);
function toggle() {
  expanded.value = !expanded.value;
  openedOnce.value = true;
  emit('toggle', expanded.value);
}
</script>

<style scoped>
.dashboard-disclosure { margin-top: 16px; }
.disclosure-toggle { display: flex; align-items: center; gap: 8px; border: 0; background: none; padding: 4px 0; color: var(--text-secondary, #6b6b6b); font: inherit; font-size: 12px; text-align: left; }
.disclosure-toggle:hover { color: var(--text-primary, #1a1a1a); }
.disclosure-toggle:focus-visible { outline: 2px solid var(--blue, #3b7dd8); outline-offset: 4px; border-radius: 2px; }
.disclosure-toggle i { transition: transform .25s ease; }
.disclosure-toggle i.expanded { transform: rotate(90deg); }
.disclosure-content { padding-top: 12px; }
@media (prefers-reduced-motion: reduce) { .disclosure-toggle i { transition: none; } }
</style>
